module.exports = __webpack_public_path__ + "static/media/_MIC2368.image.b64dca40.png";